import { render } from "./video_transcript.vue?vue&type=template&id=a6c31c9a"
import script from "./video_transcript.vue?vue&type=script&lang=js"
export * from "./video_transcript.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__